import { FilterDrawerModel } from '@_types/types';

const researchSearchFilterDrawerData: FilterDrawerModel = {
  id: 'research-filter-drawer',
  heading: 'Filters',
  subHeading: 'Select multiple filters to tailor your search results.',
  apiEndpoint: '/api/research/search',
  source: 'research-search',
  title: 'Research filter drawer',
  excludeJs: true,
  mainButton: {
    styleModifier: ['primary'],
    type: 'submit',
  },
  subButton: {
    styleModifier: ['tertiary'],
    type: 'button',
    dataSet: {
      'data-close-button': 'true',
    },
  },
  closeIconButton: {
    styleModifier: ['tertiary'],
    type: 'button',
    icon: {
      iconPath: '#kf-close2',
      viewBoxWidth: 20,
      viewBoxHeight: 20,
    },
  },
  criteria: {
    mode: 'single',
    excludeJs: true,
  },
};

export { researchSearchFilterDrawerData };
